import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "modal_update_double_sale_article",
  ref: "updateDoubleSaleArticleRef",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-225px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = {
  class: "modal-header border-bottom-0",
  id: "kt_modal_update_double_sale_article_header"
}
const _hoisted_5 = { class: "fw-bolder" }
const _hoisted_6 = {
  "data-bs-dismiss": "modal",
  class: "btn btn-icon btn-sm btn-active-icon-primary"
}
const _hoisted_7 = { class: "svg-icon svg-icon-1" }
const _hoisted_8 = { class: "modal-body py-9" }
const _hoisted_9 = { class: "dataTables_wrapper dt-bootstrap4 no-footer" }
const _hoisted_10 = { class: "table-responsive" }
const _hoisted_11 = {
  class: "table align-middle table-row-bordered table-hover fs-5 dataTable no-footer",
  role: "grid"
}
const _hoisted_12 = {
  class: "text-start text-gray-500 fw-bolder fs-5 text-uppercase gs-0",
  role: "row"
}
const _hoisted_13 = { class: "text-start ps-0" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("th", { class: "text-end border-bottom-0" }, null, -1)
const _hoisted_15 = { class: "fw-bold text-gray-800" }
const _hoisted_16 = { class: "ps-0" }
const _hoisted_17 = { class: "border-bottom-0 text-end" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { class: "svg-icon svg-icon-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg_icon = _resolveComponent("inline-svg-icon")!
  const _component_el_form = _resolveComponent("el-form")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_form, {
          model: _ctx.formData,
          rules: _ctx.rules,
          ref: "formRef"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", null, [
                _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.$t("inspection.goodsItems")), 1)
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("span", _hoisted_7, [
                  _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr061.svg" })
                ])
              ])
            ]),
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("table", _hoisted_11, [
                    _createElementVNode("thead", null, [
                      _createElementVNode("tr", _hoisted_12, [
                        _createElementVNode("th", _hoisted_13, _toDisplayString(_ctx.$t("inspection.identifier")), 1),
                        _hoisted_14
                      ])
                    ]),
                    _createElementVNode("tbody", _hoisted_15, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formData.items, (item, index) => {
                        return (_openBlock(), _createElementBlock("tr", { key: index }, [
                          _createElementVNode("td", _hoisted_16, _toDisplayString(item), 1),
                          _createElementVNode("td", _hoisted_17, [
                            _createElementVNode("span", {
                              class: "btn btn-sm btn-icon btn-light-danger",
                              onClick: ($event: any) => (_ctx.removeItem(index))
                            }, [
                              _createElementVNode("span", _hoisted_19, [
                                _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen027.svg" })
                              ])
                            ], 8, _hoisted_18)
                          ])
                        ]))
                      }), 128))
                    ])
                  ])
                ])
              ])
            ])), [
              [_directive_loading, _ctx.loading]
            ])
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ])
    ])
  ], 512))
}